import React, { useEffect } from 'react';
import { initializeApp, getApp } from 'firebase/app';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { post } from '../../util/api';

const AnonymousAuth = () => {
  useEffect(() => {
    const signIn = async () => {
      try {
        // Fetch Firebase config from the API
        const firebaseConfig = await post('/api/firebase/get-config', {});

        // Initialize Firebase app (or get existing one if already initialized)
        let app;
        try {
          app = getApp();
        } catch (e) {
          // App doesn't exist, initialize it
          app = initializeApp(firebaseConfig);
        }

        // Get auth instance
        const auth = getAuth(app);

        // Check if user is already signed in anonymously
        const currentUser = auth.currentUser;
        if (currentUser && currentUser.isAnonymous) {
          //'User is already signed in anonymously');
          return;
        }

        // If user is signed in with a different method, don't override it
        if (currentUser && !currentUser.isAnonymous) {
          //'User is already signed in with a different method');
          return;
        }

        // No user is signed in, proceed with anonymous sign-in
        await signInAnonymously(auth);
        //Anonymous authentication successful');
      } catch (error) {
        const errorCode = error.code;
        const errorMessage = error.message;
        //'Anonymous authentication failed:', errorCode, errorMessage);
      }
    };

    signIn();
  }, []);

  return <></>;
};

export default AnonymousAuth;
